import { ReactNode } from 'react'

import { TranslatedItem } from '../../../SimpleCheckList'

export const mapBulletToTranslatedItem = (bullet: ReactNode): TranslatedItem => ({ text: bullet })
